import React, {useCallback, useState} from "react";
import {animated, useTransition} from "react-spring";

const sekigaharaPages = [
    ({ style }) => <animated.div style={{ ...style, background: 'lightpink' }}>関ヶ原の戦いとは？</animated.div>,
    ({ style }) => <animated.div style={{ ...style, background: 'lightblue' }}>西暦1600年（慶長5)に起こった<br/>徳川家康（東軍）と毛利輝元（西軍）の戦いです。<br/>西軍が負けました。</animated.div>,
];

function WhatIsSekigahara() {
    const [index, set] = useState(0);

    const onClick = useCallback(() => set(state => (state + 1) % 2), []);
    const transitions = useTransition(index, p => p, {
        from: { opacity: 0, transform: 'translate3d(100%,0,0)' },
        enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
        leave: { opacity: 0, transform: 'translate3d(-50%,0,0)' },
    });

    return (
        <div className="simple-trans-main" onClick={onClick}>
            {transitions.map(({ item, props, key }) => {
                const Page = sekigaharaPages[item];
                return <Page key={key} style={props} />
            })}
        </div>
    );
}

export default WhatIsSekigahara;